import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: ''
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   alert('Thank you for your message. We will get back to you soon!');
  //   setFormData({ name: '', email: '', company: '', subject: '', message: '' });
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch('/contact.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(result.message || 'Unable to send your message.');
    }

    alert('Thank you for your message. We will get back to you soon!');

    setFormData({
      name: '',
      email: '',
      company: '',
      subject: '',
      message: '',
    });
  } catch (error) {
    console.error('Contact form error:', error);

    alert(
      error.message ||
      'Sorry, we could not send your message. Please try again later.'
    );
  }
};

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Helmet>
        <title>Contact AuVSys - Get in Touch with Our Experts</title>
        <meta name="description" content="Contact AuVSys for technology consulting, digital transformation, and enterprise solutions. Reach our global team of experts." />
      </Helmet>
      
      <div className="contact-page">
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>Contact Us</h1>
              <p>Ready to transform your business? Get in touch with our global team of technology experts.</p>
            </div>
          </div>
        </section>
        
        <section className="contact-content">
          <div className="container">
            <div className="contact-layout">
              <div className="contact-form-section">
                <h2>Send us a Message</h2>
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-row">
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name *"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email *"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-row">
                    <input
                      type="text"
                      name="company"
                      placeholder="Company Name"
                      value={formData.company}
                      onChange={handleChange}
                    />
                    <input
                      type="text"
                      name="subject"
                      placeholder="Subject *"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <textarea
                    name="message"
                    placeholder="Your Message *"
                    value={formData.message}
                    onChange={handleChange}
                    rows="6"
                    required
                  ></textarea>
                  <button type="submit" className="submit-btn">
                    <Send size={20} />
                    Send Message
                  </button>
                </form>
              </div>
              
              <div className="contact-info-section">
                <div className="contact-card">
                  <MapPin className="contact-icon" />
                  <h3>Global Headquarters</h3>
                  <p>123 Technology Drive<br/>Innovation City, IC 12345<br/>United States</p>
                </div>
                
                <div className="contact-card">
                  <Phone className="contact-icon" />
                  <h3>Phone</h3>
                  <p>Sales: +1 (555) 123-4567<br/>Support: +1 (555) 123-4568<br/>Careers: +1 (555) 123-4569</p>
                </div>
                
                <div className="contact-card">
                  <Mail className="contact-icon" />
                  <h3>Email</h3>
                  <p>hr@auvsys.com<br/>info@auvsys.com<br/>sales@auvsys.com<br/>careers@auvsys.com</p>
                </div>
                
                <div className="contact-card">
                  <Clock className="contact-icon" />
                  <h3>Business Hours</h3>
                  <p>Monday - Friday: 9:00 AM - 6:00 PM EST<br/>Saturday: 10:00 AM - 4:00 PM EST<br/>Sunday: Closed</p>
                </div>
              </div>
            </div>
            
            <div className="global-offices">
              <h2>Global Offices</h2>
              <div className="offices-grid">
                <div className="office-card">
                  <h4>North America</h4>
                  <p>New York, San Francisco, Toronto</p>
                </div>
                <div className="office-card">
                  <h4>Europe</h4>
                  <p>London, Berlin, Amsterdam</p>
                </div>
                <div className="office-card">
                  <h4>Asia Pacific</h4>
                  <p>Malaysia, Singapore, Tokyo, Sydney</p>
                </div>
                {/* <div className="office-card">
                  <h4>Malaysia</h4>
                  <p>Kuala Lumpur</p>
                </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Contact;